import { HStack, Text } from '@chakra-ui/react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'

type Props = {
  task: ChildTicketTask
  onEdit: () => void
}

export default function TaskRowActions({ task, onEdit }: Props) {
  return (
    <HStack spacing={1} onClick={(e) => e.stopPropagation()}>
      <Text
        as="button"
        type="button"
        fontSize="xs"
        color="blue.500"
        fontWeight="600"
        aria-label={`View task: ${task.title ?? task.task_number ?? 'task'}`}
        onClick={onEdit}
      >
        View task
      </Text>
    </HStack>
  )
}
